import React, { useState } from 'react'
import { HiExternalLink } from 'react-icons/hi'
import { Section } from 'components/Common'
import { StepStatus } from 'hooks/useStep'
import {
  ActionCard,
  OutlineButton,
  OpenLeatButton,
  SidePanel,
  SidePanelTitle,
  SidePanelBody
} from './styles'
import { LEAT_APP_URL } from '../../constants'
import {
  AUTH_STEP_TITLE,
  AUTH_STEP_DESCRIPTION,
  EXTERNAL_LINK_PROPS
} from './copy'
import StepLayout from '../Common/StepLayout'
import PatField from './PatField'
import LoadingPrimaryButton from './LoadingPrimaryButton'
import ExpandableImage from './ExpandableImage'
import LeatHintImage from 'packages/@slerp/assets/integrations/leat-hint.png'

interface PatEntryStepProps {
  initialToken?: string
  loading?: boolean
  onContinue: (token: string) => void
  onCancel: () => void
}

const PatEntryStep = ({
  initialToken = '',
  loading,
  onContinue,
  onCancel
}: PatEntryStepProps) => {
  const [token, setToken] = useState(initialToken)

  return (
    <StepLayout
      sidebar={
        <SidePanel>
          <ExpandableImage
            src={LeatHintImage}
            alt='Leat dashboard Auth tab showing the personal access token'
          />
          <SidePanelTitle>Where do I find this?</SidePanelTitle>
          <SidePanelBody>
            Leat dashboard → Apps → Integrations → search for Slerp → Install
            the app, and generate an Auth Token.
            <br />
            <br />
            If you have already installed the Slerp app, retrieve your old token
            or generate a new one.
          </SidePanelBody>
          <OpenLeatButton href={LEAT_APP_URL} {...EXTERNAL_LINK_PROPS}>
            OPEN LEAT <HiExternalLink />
          </OpenLeatButton>
        </SidePanel>
      }
    >
      <Section
        title={AUTH_STEP_TITLE}
        description={AUTH_STEP_DESCRIPTION}
        stepStatus={StepStatus.active}
        stepNumber={1}
      >
        <PatField id='leat-pat' value={token} onChange={setToken} />
      </Section>

      <ActionCard>
        <OutlineButton onClick={onCancel}>CANCEL</OutlineButton>
        <LoadingPrimaryButton
          disabled={!token.trim() || loading}
          loading={loading}
          onClick={() => onContinue(token.trim())}
        >
          CONTINUE
        </LoadingPrimaryButton>
      </ActionCard>
    </StepLayout>
  )
}

export default PatEntryStep
